import {useEffect, useLayoutEffect, useRef, useState} from 'react';
import Suggestions from './Suggestions.js';

export const AddressAutoComplete = ({setAddress, fieldRef, setAutocompleteVisible}) => {
  const [suggestions, setSuggestions] = useState({result: []});
  const [initial, setInitial] = useState('');
  const [suggestionIndex, setSuggestionIndex] = useState(-1);
  const suggestionIndexRef = useRef(-1);
  const [addressText, setAddressText] = useState('');
  const suggestionsRef = useRef([]);

  const clearSuggestions = () => {
    setSuggestions([]);
  };

  const getAddressSuggestions = async (search, selected) => {
    const response = await fetch('https://us-autocomplete-pro.api.smartystreets.com/lookup?auth-id=103673942335523758&search=' + encodeURIComponent(search) + '&selected=' + (selected ? encodeURIComponent(selected) : ''),
      {
        headers: {"Content-Type": "application/json"},
      }
    ).then(response => {
      response.json().then(data => { setSuggestions({result: data.suggestions}); setSuggestionIndex(0); suggestionIndexRef.current = 0} );
    });
  };

  const autocompleteOnBlur = (event) => {
    setAddressText('');
  };

  const selectSuggestion = (address, suggestion) => {
    let selected = address.replace(" more entries", "");
    selected = selected.replace(",", "");

    if (suggestion.entries && suggestion.entries > 1) {
        // this has a sub menu
        getAddressSuggestions(suggestion.street_line, selected); 
    } else {
        // select it
        //values.address1 = suggestion.street_line;
        //values.city = suggestion.city;
        //values.state = suggestion.state;
        //values.zipcode = suggestion.zipcode;
        setAddress(suggestion.street_line, suggestion.city, suggestion.state, suggestion.zipcode, suggestion.secondary);
        setSuggestions({result: []});
    }
  }

  const formatAutocompleteSuggestion = (suggestion) => {
    const street = suggestion.street_line ? `${suggestion.street_line} ` : "";
    const secondary = suggestion?.secondary ? `${suggestion.secondary} ` : "";
    const entries = suggestion?.entries > 1 ? `(${suggestion.entries} more entries) ` : "";
    const city = suggestion?.city ? `${suggestion.city} ` : "";
    const state = suggestion?.state ? `${suggestion.state}, ` : "";
    const zip = suggestion?.zipcode ? `${suggestion.zipcode}` : "";
    return street + secondary + entries + city + state + zip;
  }

  const selectFromEnter = (index) => {
      selectSuggestion(formatAutocompleteSuggestion(suggestionsRef.current[index]), suggestionsRef.current[index]);
  };

  useEffect(() => {
    if (initial) {
      if (addressText) {
          getAddressSuggestions(addressText);
      } else {
          setSuggestions({result: []});
      }  
    } else {
      setInitial(addressText);
    }
  }, [addressText]);

  useEffect(() => {
     suggestionsRef.current = suggestions.result;
     if (suggestions.result.length > 0) {
         setAutocompleteVisible(true);
     } else {
         setAutocompleteVisible(false);
     }
  }, [suggestions]);

  const autocompleteKeyUp = (event) => {
    const newVal = event.target.value;
    if (event.keyCode === 13) {
        selectFromEnter(suggestionIndexRef.current);
    } else if (event.keyCode === 40) {
        // down arrow
        if (suggestionIndexRef.current < suggestionsRef.current.length-1) {
           setSuggestionIndex(index => index + 1);
           suggestionIndexRef.current++;
        }
    } else if (event.keyCode === 38) {
        // up arrow
        if (suggestionIndexRef.current > -1) {
            setSuggestionIndex(index => index - 1);
            suggestionIndexRef.current--;
        }
    }
    setAddressText(newVal);
  };

  useLayoutEffect(() => {
    if (fieldRef.current) {
      fieldRef.current.addEventListener("keyup", autocompleteKeyUp);
      fieldRef.current.addEventListener("blur", autocompleteOnBlur);
    }
  }, [fieldRef]);

  return (
    <div>
      <Suggestions
        suggestionIndex={suggestionIndex}
        suggestions={suggestions}
        selectSuggestion={selectSuggestion}
      />
    </div>
  );
}

